import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { FaCalendarAlt } from 'react-icons/fa';

const BookAppointmentSection = styled.section`
  padding: 4rem 0;
  background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
  text-align: center;
  border-top: 1px solid rgba(255, 215, 0, 0.1);
`;

const BookAppointmentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const BookAppointmentTitle = styled(motion.h2)`
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  margin-bottom: 1rem;
  color: #ffffff;
`;

const BookAppointmentSubtitle = styled(motion.p)`
  font-size: 1.2rem;
  color: #cccccc;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const BookAppointmentButton = styled(motion.button)`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #4682B4 0%, #87CEEB 100%);
  color: #000000;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(255, 215, 0, 0.4);
  }
  
  &:as(a) {
    text-decoration: none;
  }
`;

const BookAppointment = () => {
  return (
    <BookAppointmentSection>
      <BookAppointmentContainer>
        <BookAppointmentTitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Ready to Start Your Project?
        </BookAppointmentTitle>
        <BookAppointmentSubtitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Let's schedule a consultation to discuss your ideas and bring them to life. 
          I'm here to help you achieve your digital goals.
        </BookAppointmentSubtitle>
        <BookAppointmentButton
          as={Link}
          to="/contact"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaCalendarAlt />
          Book an Appointment
        </BookAppointmentButton>
      </BookAppointmentContainer>
    </BookAppointmentSection>
  );
};

export default BookAppointment;
